import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
import { pushErrorEvent } from '../../../utils/analytics';
import { Alert } from '../../shared/alert/alert';
import { Card } from '../../shared/card/card';
import { getLastModifiedDate } from '../../../utils/date';
import { MeatballsMenu } from '../../shared/meatballs-menu/meatballs-menu';
import { usePayments } from '../../../hooks/use-payments';
import { CardType } from '../../../constants/payments';
import { ERR_UNABLE_TO_SAVE } from '../../../constants/response-error-messages';
import { CHANGES_SAVED_MSG, DELETED_CARD_MSG, DELETED_KEY_TAG, } from '../../../constants/response-success-messages';
import { getFormattedKeytag, getPaymentsErrorCode, } from '../../../utils/payments';
import { useCustomerInfo } from '../../../hooks/use-customerInfo';
import { useMeatballMenuActions } from '../../../hooks/use-meatball-payment-actions';
import { CustomerRole } from '../../../models/common/customer';
export const KeytagCard = ({ card, isMobile, index, setDeletedCreditCardIndex, onActionFailure, onActionSuccess, }) => {
    var _a;
    const { alertMessage, setAlertMessage } = usePayments();
    const { role } = useCustomerInfo();
    const { keytags } = usePayments();
    const { onEditNickName, onDelete } = useMeatballMenuActions();
    const isAdmin = role === CustomerRole.ADMIN;
    const isCardAddedByPurchaser = card.level === 'user';
    const isHiddenForAdmin = isAdmin && isCardAddedByPurchaser;
    const handleEditNickname = () => {
        const currentKeytag = (keytags === null || keytags === void 0 ? void 0 : keytags.response).find((payment) => payment.cardNumber === card.cardNumber);
        const onSuccess = () => {
            onActionSuccess(card.cardNumber, CHANGES_SAVED_MSG.message);
        };
        const onFailure = (error) => {
            const errorCode = getPaymentsErrorCode(error);
            onActionFailure(card.cardNumber, ERR_UNABLE_TO_SAVE.message);
            pushErrorEvent('edit keytag', 'inline', errorCode || 'n/a', ERR_UNABLE_TO_SAVE.message);
        };
        onEditNickName(card, currentKeytag, CardType.KEY_TAG, onSuccess, onFailure);
    };
    const handleDeleteCard = () => {
        const onSuccess = () => {
            onActionSuccess(card.cardNumber, DELETED_KEY_TAG.message);
        };
        const onFailure = (error) => {
            const errorCode = getPaymentsErrorCode(error);
            onActionFailure(card.cardNumber, ERR_UNABLE_TO_SAVE.message);
            pushErrorEvent('keytag: delete', 'inline', errorCode || 'n/a', ERR_UNABLE_TO_SAVE.message);
        };
        onDelete(card, CardType.KEY_TAG, onSuccess, onFailure, () => {
            setDeletedCreditCardIndex(index);
        });
    };
    const menuItems = [
        {
            value: 'Add/Edit Nickname',
            action: handleEditNickname,
            isHidden: !((_a = card.actions) === null || _a === void 0 ? void 0 : _a.edit),
        },
        {
            value: 'Delete',
            action: handleDeleteCard,
            isHidden: isHiddenForAdmin,
        },
    ];
    const isDeleteSuccessMessage = (alertMessage === null || alertMessage === void 0 ? void 0 : alertMessage.text) === DELETED_CARD_MSG.message;
    const mobileCardAlertMessage = isMobile &&
        (alertMessage === null || alertMessage === void 0 ? void 0 : alertMessage.paymentId) === card.cardNumber &&
        !isDeleteSuccessMessage && (React.createElement("div", { className: "sui-mb-4" },
        React.createElement(Alert, { status: alertMessage.alertStatus, onClose: () => setAlertMessage(null) }, alertMessage.text)));
    return (React.createElement(React.Fragment, null,
        mobileCardAlertMessage,
        React.createElement(Card, { isDefault: false, defaultLabel: "Default Payment Method" },
            React.createElement("div", { className: `sui-flex sui-justify-between sui-align-center ${card.cardNickName ? 'sui-mb-2' : 'sui-mb-3'}` },
                React.createElement("h3", { className: "sui-font-display sui-text-3xl sui-mr-4 sui-truncate sui-text-primary", "aria-label": "nickname" }, card.cardNickName),
                React.createElement("div", null,
                    React.createElement(MeatballsMenu, { label: "Payment", items: menuItems }))),
            React.createElement("div", { className: "sui-mb-6 sui-whitespace-nowrap" },
                React.createElement(Typography, { variant: "body-lg", color: "subtle", "data-testid": "card number" }, getFormattedKeytag(card))),
            card.addedBy && (React.createElement("div", { className: "sui-overflow-hidden" },
                React.createElement(Typography, { truncate: true, color: "subtle" },
                    "Added by ",
                    React.createElement("span", { "data-qm-mask": "" }, card.addedBy)))),
            card.lastModifiedDate && (React.createElement(Typography, { color: "subtle" },
                "Last edited ",
                getLastModifiedDate(card.lastModifiedDate))))));
};
KeytagCard.displayName = 'KeytagCard';
